// extracted by mini-css-extract-plugin
export default {"panel":"SupportForm_panel__nB4Jf","head":"SupportForm_head__1PlzT","headIcon":"SupportForm_headIcon__ta05d","body":"SupportForm_body__r2mi+"};